import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, BrainIcon, ActivityIcon, TargetIcon, TrendingUpIcon, HeartPulseIcon, CalendarIcon } from 'lucide-react';
const modules = [{
  title: 'Módulo 1 — Mentalidad y preparación del jugador',
  icon: BrainIcon,
  content: ['El jugador que mejora fuera de la cancha', 'Metas reales en 30, 60 y 90 días', 'Rutina de activación mental pre-entrenamiento', 'Cómo estudiar tus partidos aunque no tengas video', 'El error más común del jugador amateur — y cómo evitarlo']
}, {
  title: 'Módulo 2 — Físico específico para básquet',
  icon: ActivityIcon,
  content: ['Las capacidades físicas clave por posición', 'Protocolos de salto vertical con progresión real', 'Velocidad y cambio de dirección sin lesionarte', 'Fuerza funcional aplicada al básquet, sin gimnasio obligatorio', 'Resistencia aeróbica para no morir en el 4° cuarto']
}, {
  title: 'Módulo 3 — Habilidades técnicas individuales',
  icon: TargetIcon,
  content: ['Manejo de balón: ejercicios de solo training por nivel', 'Mecánica del tiro, puntos de control y rutinas de repetición', 'Layup, euro-step y finalizaciones básicas', 'Defensa individual: posición, pies y lectura del oponente', 'El 1 vs 1 ofensivo: crear ventaja desde el dribling']
}, {
  title: 'Módulo 4 — Conceptos tácticos para el partido',
  icon: TrendingUpIcon,
  content: ['Cómo tomar mejores decisiones en tiempo real', 'Cortes, apantallas y movilidad sin balón', 'Cómo atacar la zona 2-3 y la defensa en hombre', 'Qué hacer en los primeros 3 segundos del contraataque', 'Los errores tácticos más frecuentes del jugador de 16 a 35 años']
}, {
  title: 'Módulo 5 — Recuperación y prevención de lesiones',
  icon: HeartPulseIcon,
  content: ['Las lesiones más comunes en básquet amateur y cómo prevenirlas', 'Rutina de elongación post-entrenamiento y post-partido', 'Cómo dormir, hidratarte y alimentarte para rendir más', 'Señales de sobreentrenamiento', 'Plan de vuelta al juego después de una pausa']
}, {
  title: 'Módulo 6 — Plan de entrenamiento semanal',
  icon: CalendarIcon,
  content: ['Cómo distribuir tus sesiones según tus días disponibles', 'Semana tipo para jugador con 2, 3 o 4 días libres', 'Cómo combinar trabajo físico y técnico en una sola sesión', 'Progresión de 8 semanas: de base a pico de rendimiento', 'Cómo ajustar el plan en semana de partido']
}];
export function Modules() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-gray-50 py-12 md:py-16 px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <div className="space-y-4" data-id="element-70">
          {modules.map((module, index) => {
          const Icon = module.icon;
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-blue-100 hover:border-blue-300 transition-colors" data-id="element-71">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 text-left hover:bg-blue-50 transition-colors" data-id="element-72">
                  <div className="flex items-center gap-3" data-id="element-73">
                    <Icon className="w-6 h-6 text-orange-500 flex-shrink-0" data-id="element-74" />
                    <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-75">
                      {module.title}
                    </h3>
                  </div>
                  <ChevronDownIcon className={`w-6 h-6 text-blue-600 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-76" />
                </button>

                <AnimatePresence data-id="element-77">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-78">
                      <div className="p-5 pt-0 border-t border-gray-100" data-id="element-79">
                        <ul className="space-y-3" data-id="element-80">
                          {module.content.map((item, itemIndex) => <li key={itemIndex} className="flex items-start gap-2 text-gray-700" data-id="element-81">
                              <span className="text-orange-500 font-bold mt-1" data-id="element-82">
                                •
                              </span>
                              <span data-id="element-83">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}